<script>
export default {
  name: 'VcLayout',
  render: function (createElement) {
    // `<v-layout><slot></slot></v-layout>`
    const props = {
      attrs: { ...this.$attrs },
      on: { ...this.$listeners },
      ref: this.$vnode.data.ref,
      style: this.$vnode.data.style,
    };
    return createElement('v-layout', props, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped></style>
